import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { editEmpProfileAlbumsApi } from "../../API/API";

function* editEmpAlbumsSaga(params) {
  try {
    const response = yield call(editEmpProfileAlbumsApi, params);
    yield put({
      type: types.EDIT_EMP_ALBUMS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.EDIT_EMP_ALBUMS_FAILURE, error });
  }
}

export function* watchEditEmpAlbumsSaga() {
  yield takeEvery(types.EDIT_EMP_ALBUMS_REQUESTED, editEmpAlbumsSaga);
}
